import { NavLink } from 'react-router-dom';
import Icon, { type IconProps } from '../../../icon';
import { H6 } from '../../../title';
import { Div, Flex } from '../../../box';
import Button from '../../../button';
import { useSidebarContext } from '../sidebar-context';

type Props = {
  icon: IconProps['name'];
  title: string;
  path?: string;
  href?: string;
  'data-testid'?: string;
};

export function SidebarItem({ icon, title, ...restProps }: Props) {
  const { mode, onItemFocus, setActivePath, activePath } = useSidebarContext();
  const isCurrent = restProps.path ? activePath?.includes(restProps.path) : false;

  return (
    <Div paddingHorizontal={'xs'} alignItems={'center'}>
      <Button
        onFocus={onItemFocus}
        size={'auto'}
        style={
          mode === 'collapsed'
            ? {
                borderRadius: 8,
                justifyContent: 'center',
              }
            : {
                justifyContent: 'flex-start',
                borderBottomRightRadius: 24,
                borderTopRightRadius: 24,
              }
        }
        onClick={() => {
          setActivePath(restProps.path || '');
        }}
        variant={'secondary-clean'}
        target={restProps.href ? '_blank' : undefined}
        componentClass={restProps?.href ? 'a' : NavLink}
        to={restProps.path}
        href={restProps.href}
        data-testid={restProps['data-testid']}
        block
      >
        <Flex padding={'xs'} alignItems={'center'}>
          <Icon variant={'gray900'} size={'xxl'} name={icon} outlined={!isCurrent} />

          <div hidden={mode === 'collapsed'}>
            <H6 marginVertical={'none'} marginLeft={'sm'}>
              {title}
            </H6>
          </div>
        </Flex>
      </Button>
    </Div>
  );
}
